module.exports = __webpack_public_path__ + "img/ethereum.2127cfcb.svg";